var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "execution" },
    [
      _c(
        "basic-container",
        [
          _c("avue-crud", {
            ref: "crud",
            attrs: {
              data: _vm.tableData,
              option: _vm.tableOption,
              page: _vm.page,
              permission: _vm.permissionList,
              "table-loading": _vm.tableLoading,
            },
            on: {
              "update:page": function ($event) {
                _vm.page = $event
              },
              "on-load": _vm.getList,
              "row-update": _vm.handleUpdate,
              "row-save": _vm.handleSave,
              "search-change": _vm.searchChange,
              "size-change": _vm.sizeChange,
              "current-change": _vm.currentChange,
              "row-del": _vm.rowDel,
            },
            scopedSlots: _vm._u([
              {
                key: "menu",
                fn: function (scope) {
                  return [
                    _vm.permissions.sys_dict_add
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              icon: "el-icon-menu",
                              size: "small",
                              type: "text",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleItem(scope.row, scope.index)
                              },
                            },
                          },
                          [_vm._v("\n\t\t\t\t\t字典项\n\t\t\t\t")]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogFormVisible,
            title: "字典项管理",
            width: "90%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
            close: _vm.dictItemVisible,
          },
        },
        [
          _c("avue-crud", {
            ref: "crudItem",
            attrs: {
              "before-open": _vm.onHandleBeforeOpen,
              data: _vm.tableDictItemData,
              option: _vm.tableDictItemOption,
              page: _vm.itemPage,
              permission: _vm.permissionList,
            },
            on: {
              "update:page": function ($event) {
                _vm.itemPage = $event
              },
              "size-change": _vm.itemSizeChange,
              "current-change": _vm.itemCurrentChange,
              "row-update": _vm.handleItemUpdate,
              "row-save": _vm.handleItemSave,
              "row-del": _vm.rowItemDel,
            },
            model: {
              value: _vm.form,
              callback: function ($$v) {
                _vm.form = $$v
              },
              expression: "form",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }